var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStar2Icon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5.682l.255 1.829c.228 1.636 1.313 2.918 2.697 3.188l1.548.3-1.548.302c-1.384.27-2.469 1.552-2.697 3.188L4.5 11.318l-.255-1.83c-.228-1.635-1.313-2.917-2.697-3.187L0 6l1.548-.301c1.384-.27 2.469-1.552 2.697-3.188L4.5.68z",
    fill: "#fff"
  })));
}

export default SvgStar2Icon;